import { Query, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import {
  DescriptionInputDataKey,
  InputDataPageType,
} from '../../input-data/schema/types';
import { InputDataPageSchema } from '../../input-data/schema/InputDataSchema';
import { DataObjectUrl } from './DataObjectUrl';

const queryKey = ['useDescriptionInputData'] as const;

const getDescriptionInputData = async (
  params?: DescriptionInputDataKey,
): Promise<InputDataPageType> =>
  apiClient
    .get<InputDataPageType>(expand(DataObjectUrl.INPUT_DATA, params))
    .then((response) => InputDataPageSchema.parse(response.data));

export const useDescriptionInputDataQuery = createApiQueryHook(
  queryKey,
  getDescriptionInputData,
);

export const useRefetchDescriptionInputDataQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.refetchQueries({
        predicate: (query: Query) =>
          query.queryKey.toString().includes('useDescriptionInputData'),
      }),
    [queryClient],
  );
};
